/**
 * Canonical type stacks and scale. Inter is the product face (load 400/500/600
 * via @fontsource), JetBrains Mono the code face.
 */
export const fontFamilyUI =
  '"Inter", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif';

export const fontFamilyMono =
  '"JetBrains Mono", ui-monospace, SFMono-Regular, Menlo, monospace';

/**
 * Heading scale: deliberately tighter than MUI's defaults (h1 there is 6rem)
 * but conservative enough not to collapse existing layouts. 600 is the bold
 * weight of record — 700 stays available for the rare display moment.
 */
export const typeScale = {
  h1: { fontSize: "2.5rem", fontWeight: 700, lineHeight: 1.2, letterSpacing: "-0.02em" },
  h2: { fontSize: "2rem", fontWeight: 700, lineHeight: 1.25, letterSpacing: "-0.015em" },
  h3: { fontSize: "1.75rem", fontWeight: 600, lineHeight: 1.3, letterSpacing: "-0.01em" },
  h4: { fontSize: "1.5rem", fontWeight: 600, lineHeight: 1.35 },
  h5: { fontSize: "1.25rem", fontWeight: 600, lineHeight: 1.4 },
  h6: { fontSize: "1.125rem", fontWeight: 600, lineHeight: 1.45 },
  subtitle1: { fontSize: "1rem", fontWeight: 500, lineHeight: 1.5 },
  subtitle2: { fontSize: "0.875rem", fontWeight: 500, lineHeight: 1.5 },
  body1: { fontSize: "1rem", fontWeight: 400, lineHeight: 1.5 },
  body2: { fontSize: "0.875rem", fontWeight: 400, lineHeight: 1.5 },
  button: { fontSize: "0.875rem", fontWeight: 600, lineHeight: 1.75, textTransform: "none" as const },
  caption: { fontSize: "0.75rem", fontWeight: 400, lineHeight: 1.5 },
} as const;
